import useNav from '@core/layouts/composable/useNav'
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router/composables'

export default function useHorizontalNavMenuLink(item) {
  const { app } = useRouter()
  const { isNavLinkActive, navLinkProps } = useNav()

  const isActive = ref(false)

  const linkProps = navLinkProps.value(item)

  watch(
    () => app._route.name,
    () => {
      isActive.value = isNavLinkActive(item)
    },
    { immediate: true },
  )

  return {
    isActive,
    linkProps,
  }
}
